const validComparableTypes = new Set(['string', 'number', 'boolean']);

const validator = conditions => {
  return rule => {
    for (const [message, test] of Object.entries(conditions)) {
      if (!test(rule)) {
        return { isValid: false, message };
      }
    }

    return { isValid: true };
  }
};

const setRuleValidator = validator({
  'Rule must have a `arrayName` property': rule => 'arrayName' in rule,
  "Rule's `arrayName` property must be a string": rule => typeof rule.arrayName === 'string',
  'Rule must have a `elements` property': rule => 'elements' in rule,
  'Rule `elements` must be an Array': rule => Array.isArray(rule.elements),
  'Rule `elements` items must be strings, numbers, or booleans': rule => rule.elements.every(item => validComparableTypes.has(typeof item))
});

module.exports = {
  validComparableTypes,
  validator,
  setRuleValidator,
};
